import {
  Component,
  effect,
  ElementRef,
  inject,
  input, output,
  viewChild,
} from '@angular/core';
import { ModalsService } from 'src/app/services/Modals/modals.service';
import { filesize } from 'filesize';

@Component({
  selector: 'image-picker',
  imports: [],
  templateUrl: './image-picker.component.html',
  styleUrl: './image-picker.component.scss',
})
export class ImagePickerComponent {
  // refs
  file_input = viewChild<ElementRef>('file_input');

  // injectables
  modals = inject(ModalsService);

  // component deps
  width = input<string>('100%');
  max_size = input<number>(10485760);
  message = input<string>();
  accepts = input<string>('.bmp, .jpg , .jpeg , .png., .gif'); // default
  url = input<string | undefined>(undefined);
  withClearSelection = input<boolean>(false)
  editMode = input<boolean>(true)
  file_as = input<'string' | 'blob'>('blob')

  // outputs
  fileUpload = output<File>()
  imageUpload = output<string>()

  // data
  public imageUrl: string | undefined = '';
  allowed_ext: string[] = [];
  file!: File | undefined;

  constructor() {
    effect(() => {
      this.imageUrl = this.url();
    });
  }

  ngOnInit() {
    this.allowed_ext = this.accepts()
      .split(',')
      .map((i) => i.trim().replace('.', ''));
  }

  getFile() {
    return this.file;
  }

  onSelect(event: any) {
    if (event.target.files.length == 0) {
      return;
    }
    this.selectFile(event.target.files[0]);
    event.target.value = '';
  }

  drop(event: any) {
    event.preventDefault();
    if (event.dataTransfer.files.length == 0) {
      return;
    }
    this.selectFile(event.dataTransfer.files[0]);
  }

  selectFile(file: File) {
    if (!this.allowed_ext.includes(this.getExtension(file).toLowerCase())) {
      this.modals.getInstance()?.showInfo('Error', 'Invalid file type', 'OK');
      return;
    }

    if (file.size > this.max_size()) {
      this.modals.getInstance()?.showInfo(
        'Error',
        `Maximum of ${filesize(this.max_size(), {
          base: 2,
          standard: 'jedec',
        })} only!`,
        'OK',
      );
      return;
    }

    this.imageUrl = URL.createObjectURL(file);
    this.fileUpload.emit(file);
    this.imageUpload.emit(this.imageUrl);
    this.file = file;
  }

  dragOver(event: any) {
    event.preventDefault();
  }

  getExtension(file: File) {
    return file.name.split('.').pop() ?? '--';
  }

  reset() {
    this.file = undefined;
    this.imageUrl = undefined;
  }
}
